import { useState } from 'react';
import { type Moment } from 'moment';

import { ReactComponent as ArrowDown } from '../../../assets/arrow-down.svg';
import { ReactComponent as CaretLeft } from '../../../assets/caret-left.svg';
import { ReactComponent as CaretRight } from '../../../assets/caret-right.svg';

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export default function DatePicker ({ value, onChange }: { value: Moment; onChange: (value: Moment) => void; }) {
  const [isOpen, setIsOpen] = useState(false);
  const [calendar, setCalendar] = useState<Moment>(value);

  const previousMonth = calendar.clone().add(-1, 'M');
  const nextMonth = calendar.clone().add(1, 'M');

  const addYears = (year: number) => {
    const newCalendar = calendar.clone().add(year, 'year');
    setCalendar(newCalendar);
  };

  const addMonths = (month: number) => {
    const newCalendar = calendar.clone().add(month, 'M');
    setCalendar(newCalendar);
  };

  const isSelected = (day: number) => {
    if (calendar.year() !== value.year()) return false;
    if (calendar.month() !== value.month()) return false;
    return day === value.date();
  };

  const isDisabled = (date: Moment) => {
    return date.isBefore(new Date(), 'day');
  };

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex', height: '40px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            width: '200px',
            lineHeight: '100%',
            border: '1px solid #006EC2',
            borderTopLeftRadius: 2,
            borderBottomLeftRadius: 2,
            padding: '8 15 8 15',
          }}
        >
          <span style={{ fontSize: '18px' }}>{value.format('DD/MM/YYYY')}</span>
        </div>
        <div
          style={{
            minWidth: '40px',
            backgroundColor: '#006EC2',
            borderRadius: '2px',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
          onClick={() => { setIsOpen(prev => !prev); }}
        >
          <ArrowDown width="12" />
        </div>
      </div>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '470px',
            backgroundColor: '#fff',
            zIndex: 1,
            boxShadow: '0px 3px 6px #00000029',
          }}
        >
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '25px', alignItems: 'center', margin: '25px 40px' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <CaretLeft onClick={() => { addYears(-1); }} />
              <span style={{ color: '#006EC2', fontSize: '18px', fontWeight: 'bold' }}>{calendar.format('YYYY')}</span>
              <CaretRight onClick={() => { addYears(1); }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '50px' }}>
              <span
                style={{ color: '#74B1E0', fontSize: '18px', width: '100px', textAlign: 'center' }}
                onClick={() => { addMonths(-1); }}
              >
                {previousMonth.format('MMMM')}
              </span>
              <span
                style={{ color: '#006EC2', fontSize: '18px', width: '100px', textAlign: 'center', fontWeight: 'bold' }}
              >
                {calendar.format('MMMM')}
              </span>
              <span
                style={{ color: '#74B1E0', fontSize: '18px', width: '100px', textAlign: 'center' }}
                onClick={() => { addMonths(1); }}
              >
                {nextMonth.format('MMMM')}
              </span>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                {days.map(day => (
                  <span style={{ fontSize: '16px', width: '40px', fontWeight: 'bold', textAlign: 'center' }} key={day}>
                    {day}
                  </span>
                ))}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '10px',
                  columnGap: '20px',
                  flexWrap: 'wrap',
                }}
              >
                {Array.from({ length: calendar.clone().startOf('month').day() }).map((_, index) => (
                  <div
                    style={{ fontSize: '16px', width: '40px', height: '40px', textAlign: 'center' }}
                    key={index}
                  ></div>
                ))}
                {Array.from({ length: calendar.daysInMonth() }).map((_, index) => (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                      width: '40px',
                      height: '40px',
                      color: isDisabled(calendar.clone().date(index + 1)) ? '#74B1E0' : '#000',
                      backgroundColor: isSelected(index + 1) ? '#DFF1FF' : '#fff',
                      borderRadius: '50%',
                    }}
                    key={index}
                    onClick={() => {
                      if (isDisabled(calendar.clone().date(index + 1))) return;
                      onChange(calendar.clone().date(index + 1));
                      setIsOpen(false);
                    }}
                  >
                    <span>{index + 1}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
